module.exports = __webpack_public_path__ + "static/link-rte-highlight-360f2477d84d429c7b833f6a5d071011.png";